export const NEWS_AUTHOR_HANDLE = 'sparkinfo.bsky.social'
export const NEWS_REQUIRED_TAG = '#tellusarticle'
